  @if (isInternal) {
  <div class="card-container">
    @for (company of recentCompanies; track company) {
    <mat-card class="home-card mat-elevation-z6">
      <div class="top-section">
        <app-apps-photo [image]="company && company.image" [app]="company" aria-label="user-image">
        </app-apps-photo>
      </div>

      <div class="bottom-section">
        <div class="name">{{(company.name)}}</div>
        <div class="default-description" >
          {{(company.address=== undefined) || (company.location=== undefined)
          ||(company.address=== null) || (company.location=== null)||
          (company.address.trim()=== "") || (company.location.trim()=== "")?
          company?.address+company?.location : company.address+', '+company.location }}
        </div>
        @if (!company.location) {
        <div>{{
          'APP_DETAILS.default_description' | translate
          }}</div>
        }
      </div>
      <mat-card-actions>
        <button mat-stroked-button color="primary" (click)="navigateToUserPage(company)">
          {{ 'ACTION.open' | translate}}
        </button></mat-card-actions>
    </mat-card>
    }
@if ((!recentCompanies || recentCompanies.length === 0) && isInternal) {
<div class="empty-message">
  <span>{{ 'Company_Noresults' | translate }}</span>
</div>
}
</div>
  }
